export default "__VITE_ASSET__pgVEov9f__"